import createValidator from 'revalidate/lib/createValidator';
import { INPUT_MUST_BE_ALPHABETIC } from '../constants/defaultErrorMessages';
const extendedLatinCharactersFormat = /^([A-Za-z'\-\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/;
const isLatinAlphabetic = createValidator(message => value => value && !extendedLatinCharactersFormat.test(value) ? message || INPUT_MUST_BE_ALPHABETIC : null, INPUT_MUST_BE_ALPHABETIC);
export default isLatinAlphabetic;
//# sourceMappingURL=isLatinAlphabetic.js.map